/**
 * Utilitários de exibição de valores monetários.
 *
 * ATENÇÃO: este módulo serve apenas para FORMATAR valores na tela.
 * Cálculos de comissão e bônus são feitos na API com Decimal (precisão exata),
 * nunca com `number` (ponto flutuante): 0.1 + 0.2 !== 0.3 em JavaScript.
 *
 * A API trafega valores monetários como string decimal ("1234.56")
 * justamente para não perder precisão no JSON.
 */

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const percentFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

/** String decimal com até 2 casas, ponto como separador. Ex.: "1234.56", "-10", "0.5". */
const DECIMAL_STRING_REGEX = /^-?\d+(\.\d{1,2})?$/;

export function isDecimalString(value: unknown): value is string {
  return typeof value === 'string' && DECIMAL_STRING_REGEX.test(value);
}

/** "1234.5" -> "R$ 1.234,50" (o espaço é não separável, padrão do Intl). */
export function formatBRL(value: string | number): string {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) {
    throw new Error(`Valor monetário inválido: "${value}"`);
  }
  return brlFormatter.format(n);
}

/** Fração para percentual: "0.8765" -> "87,65%". */
export function formatPercent(fraction: string | number): string {
  const n = typeof fraction === 'number' ? fraction : Number(fraction);
  if (!Number.isFinite(n)) {
    throw new Error(`Percentual inválido: "${fraction}"`);
  }
  return percentFormatter.format(n);
}
